import { render, staticRenderFns } from "./PreparePaymentScreen.vue?vue&type=template&id=10b15fe6&scoped=true&"
import script from "./PreparePaymentScreen.vue?vue&type=script&lang=js&"
export * from "./PreparePaymentScreen.vue?vue&type=script&lang=js&"
import style0 from "./PreparePaymentScreen.vue?vue&type=style&index=0&id=10b15fe6&prod&lang=scss&"
import style1 from "./PreparePaymentScreen.vue?vue&type=style&index=1&id=10b15fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b15fe6",
  null
  
)

export default component.exports